<div class="signup-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <h1>Cadastre-se</h1>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      @if (status === 'success') {
        <div class="signup-status" role="status">
          <mat-icon
            class="material-symbols-outlined status-icon success-icon"
            aria-hidden="true"
          >
            check_circle
          </mat-icon>
          <p class="mat-headline-small status-text">
            Enviamos uma mensagem para o endereço informado. Acesse seu e-mail e confirme para concluir o cadastro.
          </p>
        </div>
      } @else {
        @if (status === 'error') {
          <div class="signup-status signup-status--error" role="alert">
            <mat-icon
              class="material-symbols-outlined status-icon"
              color="warn"
              aria-hidden="true"
            >
              x_circle
            </mat-icon>
            <p class="mat-headline-small status-text">
              Houve um erro ao cadastrar. Tente novamente mais tarde.
            </p>
          </div>
        }

        <app-user-form
          #userForm
          mode="create"
          [showTermsAcceptance]="true"
          (saveResult)="onSaveResult($event)"
        ></app-user-form>
        <button mat-raised-button color="primary" (click)="submit(userForm)" [disabled]="userForm.isSaving">
          @if (userForm.isSaving) {
            <mat-spinner diameter="20"></mat-spinner>
          }
          @if (!userForm.isSaving) {
            <span>Cadastrar</span>
          }
        </button>
      }
    </mat-card-content>
  </mat-card>
</div>
